import type { SbStage, StoryboardHistory } from '@agentic-ivy/shared-types';
import type { StoryboardVersion } from '@/services/storyboardApi';

const STAGE_LABELS: Record<SbStage, string> = { mood: 'Mood board', plan: 'Plan', built: 'Review' };

export interface StoryboardPage {
  version: number;
  label: string;
  date: string;
  note: string | null;
  /** The newest page: where the video is. */
  newest: boolean;
  /** The page open now. */
  here: boolean;
}

/**
 * Every storyboard page you can open, newest first. With the page history (a served page) these are the pages
 * the storyboard itself offered in its stage tabs and History, named by stage; without it, every version.
 */
export function storyboardPages(history: StoryboardHistory | null, versions: StoryboardVersion[], selected: number | null): StoryboardPage[] {
  const known = new Map(versions.map((v) => [v.version, v]));
  const newest = Math.max(...versions.map((v) => v.version));
  const rows = history
    ? history.versions
        .filter((e) => known.has(e.version))
        .map((e) => ({ version: e.version, label: `${e.stage ? STAGE_LABELS[e.stage] : 'Storyboard'} · v${e.version}`, date: e.date, note: e.changeSummary }))
    : versions.map((v) => ({ version: v.version, label: `v${v.version}`, date: v.createdAt.slice(0, 10), note: v.changeSummary }));
  return rows
    .sort((a, b) => b.version - a.version)
    .map((r) => ({ ...r, newest: r.version === newest, here: r.version === selected }));
}
